/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ReportPageScopeType } from './ReportPageScopeType';

export type ReportPageEditRead = {
    id: string;
    action: ReportPageEditRead.action;
    editedFields: Array<string>;
    reportConditionId?: (string | null);
    reportInstanceId?: (string | null);
    entityId?: (string | null);
    reportPageId?: (string | null);
    reportId?: (string | null);
    index?: (number | null);
    pageWidth?: (number | null);
    pageHeight?: (number | null);
    scope?: (ReportPageScopeType | null);
    thumbnailS3Key?: (string | null);
    thumbnailVersion?: number;
    thumbnailUrl?: (string | null);
};

export namespace ReportPageEditRead {

    export enum action {
        ADD = 'add',
        EDIT = 'edit',
        REMOVE = 'remove',
    }


}

